module.exports = __webpack_public_path__ + "static/lifetime-fitness-bronze-membership-icon-adae3cb870ce48fa593518bc623dd729.svg";